import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { AddComponentService } from "../../services/addComponent/add-component.service";

//variable del global scope para utilizar jquery
declare var $: any;

//variables del global scope para el control del webtour
declare var tour: any;
declare var tourInsor: any;

@Component({
  selector: 'app-web.tour',
  templateUrl: './web.tour.component.html',
  styleUrls: ['./web.tour.component.css']
})
export class WebTourComponent implements OnInit {

  public currentLanguage: string;

  //constructor de la clase
  constructor(private _router: Router,
    private _translateService: TranslateService,
    public _configurationControlService: ConfigurationControlService,
    private _routingValidationService: RoutingValidationService,
    private _configurationService: ConfigurationService,
    private _welcomeDataService: WelcomeService,
    private _addComponentService: AddComponentService
  ) {
    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    // this._translateService.use(_configurationControlService.examConfiguration.language);
    this.currentLanguage = _configurationControlService.examConfiguration.language || 'es';
    this._translateService.use(this.currentLanguage);
    this._configurationControlService.habilitarAudio = true;
    this._configurationControlService.habilitarContraste = true;
    this._configurationControlService.habilitarFuente = true;
    setTimeout(function () { $("#menuAccess").css("z-index", "1"); }, 10);

  }


  /*Necesario debido a la implementacion de la interfaz OnInit
    se encarga de iniciar la funcionalidad del tour*/
  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras();
    this._addComponentService.lowContrast();
    switch (this._configurationControlService.examConfiguration.tourTest) {
      case "ESTANDAR":
      case "ADAPTATIVA":
        tour.start();
        tour.restart();
        break;
      case "INSOR":
        tourInsor.start();
        tourInsor.restart();
        break;
      case "INCI":
        this._router.navigate(['/webTourInci']);
        break;
      case "NINGUNO":
        this.startTest();
        break;
      default:
        this.startTest();
        break;
    }
  }

  // Método para cambiar el idioma
  public changeLanguage(lang: string) {
    this.currentLanguage = lang;
    this._translateService.use(lang);
    this._configurationControlService.examConfiguration.language = lang;

    // Opcional: guardar en localStorage para persistencia
    localStorage.setItem('preferredLanguage', lang);
  }

  //Se encarga del cargue de los videos
  public loadAnotherVideo(url: any) {
    url = "/src/app/resources/videosTourINSOR/" + url;
    var video = document.getElementsByTagName('video')[0];
    var sources = video.getElementsByTagName('source');
    sources[0].src = url;
    video.load();
    video.play();
  }


  /*Es invocado cuando se hace click en finalizar el tour de ayuda
    y se encarga de navegar hacia el visualizador*/
  public startTest() {
    this._routingValidationService.validateRouting("tourToExam");
  }

}
